import React from 'react';
import Header from './header/Header';
import Socialbar from './socialbar/Socialbar';
import { Container } from 'react-bootstrap';
import Footer from './Footer/Footer';
import { useEffect } from 'react';
import allProjects from '../data/projects.json';
import Blogs from '../data/blogs.json';
import { useState } from 'react';
import { createContext } from 'react';
import { Helmet } from 'react-helmet';


export const DataContext = createContext();

const Layouts = ({children}) => {
    const [allWorks, setAllWorks] = useState([]);
    const [allBlogs, setAllBlogs] = useState([]);

    useEffect(() => {
        setAllWorks(allProjects);
        setAllBlogs(Blogs);
    }, []);

    return (
        <>
            <Helmet title={"Solaiman Shadin - Personal Website"} defer={false} />
            <Header/>
            <main>
                <Socialbar/>
                <Container>
                    <DataContext.Provider value={{allWorks, allBlogs}}>
                        {/* <a className="text-white" href="/">
                            <section class="bg-dark p-3">
                                <i class="fa fa-long-arrow-left" aria-hidden="true"></i> Back To Home
                            </section>
                        </a> */}
                        {children}
                    </DataContext.Provider>
                </Container>
            </main>
            <Footer/>
        </>
    );
};

export default Layouts;